// @core
import { useEffect } from 'react';
import { connect } from 'react-redux';
const { withRouter } = require('react-router-dom');

import { i18n } from 'core/i18n';
// @components
import { OKCover } from 'commonsComponents/OKCover';
import { OKHeaderSubPage } from 'commonsComponents/OKHeaderSubPage';

import { getBreadcrumb } from './helpers/bringAccountHelper';
import { BringAccountFlowContent } from './components/bringAccountFlowContent/bringAccountFlowContent';
import { isPrintOfficeMode } from 'utilities/contactCenter/printerHelper';

import bringAccountActions from 'actions/bringAccount';

import './bringAccountView.scss';

const { formatText } = i18n;

const BringAccountView = ({
    match,
    history,
    immAccounts,
    immBringAccount,
    immProfile,
    immFlagBasedFeatures,
    resetTransferState,
    setIban,
    setVisibleStep,
    validateStep,
    getEntityName,
    setExecutionDate,
    updateAuthoriseCheckbox,
    sendTransferRequest,
    downloadTransferDocument,
    printTransferDocument,
    setInvalidExecutionDate,
}) => {
    const accountId = match.params.accountId;
    const immAccount = immAccounts.get('byId').get(accountId);
    const isOffice = __CONTACT_CENTER__ && isPrintOfficeMode()
    const isPrivateWeb = !__CONTACT_CENTER__
    const interveners = immAccount.get('interveners');
    const hasInterveners = interveners?.get('list')?.size

    useEffect(() => {
        const interveners = immAccount.get('interveners');

        if (interveners.get('error')) {
            return;
        }

        if (!interveners || (!interveners.get('fetchSuccess') && !interveners.get('isLoading'))) {
            history.push('/myprofile/accounts');
        }
    }, []);

    useEffect(() => {
        return () => {
            resetTransferState();
        }
    }, [])

    return (
        <div className="transfer-account">
            <div className="container-fluid">
                <div>
                    <div className="row">
                        <OKCover size="small" section="accounts" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={getBreadcrumb(immAccount)}
                                finalTitle={formatText('transfer_account-transfer_account_from_another_bank_step1_title')}
                            />
                        </OKCover>
                    </div>
                    <div className="grid-view__body deposits-renovations-cancel-account__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative deposits-renovations-cancel-account__content-position-negative">
                                <BringAccountFlowContent
                                    immBringAccount={immBringAccount}
                                    immProfile={immProfile}
                                    immAccount={immAccount}
                                    immFlagBasedFeatures={immFlagBasedFeatures}
                                    history={history}
                                    isOffice={isOffice}
                                    isPrivateWeb={isPrivateWeb}
                                    hasInterveners={hasInterveners}
                                    actions={{
                                        setIban,
                                        setVisibleStep,
                                        validateStep,
                                        getEntityName,
                                        setExecutionDate,
                                        updateAuthoriseCheckbox,
                                        sendTransferRequest,
                                        downloadTransferDocument,
                                        printTransferDocument,
                                        setInvalidExecutionDate,
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    immBringAccount: state.bringAccount,
    immProfile: state.profile,
    immFlagBasedFeatures: state.flagBasedFeatures,
    immAccounts: state.accounts,
});

export const ConnectedBringAccountView = withRouter(connect(mapStateToProps, {
    // actions
    setIban: bringAccountActions.setIbanToTransfer,
    setVisibleStep: bringAccountActions.setVisibleStep,
    validateStep: bringAccountActions.validateStep,
    setResetState: bringAccountActions.setResetState,
    getEntityName: bringAccountActions.getEntityName,
    setExecutionDate: bringAccountActions.setExecutionDate,
    updateAuthoriseCheckbox: bringAccountActions.updateAuthoriseCheckbox,
    sendTransferRequest: bringAccountActions.sendTransferRequest,
    downloadTransferDocument: bringAccountActions.downloadTransferDocument,
    printTransferDocument: bringAccountActions.printTransferDocument,
    resetTransferState: bringAccountActions.resetTransferState,
    setInvalidExecutionDate: bringAccountActions.setInvalidExecutionDate,
})(BringAccountView));

export { ConnectedBringAccountView as BringAccountView };
